import { CircularProgress, Stack, Typography } from "@mui/material";
import { CheckInCircleIcon } from "../../../../images";
import { CustomButton } from "../../../../ui/CustomButton";
import { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  text: string;
  btnHandler: () => void;
  isLoading: boolean;
  isSynced: boolean;
  isDisabled: boolean;
  customBtnBlock?: ReactNode;
  extraBtn?: ReactNode;
};

export const Method = ({
  icon,
  title,
  text,
  btnHandler,
  isLoading,
  isSynced,
  isDisabled,
  customBtnBlock,
  extraBtn,
}: Props) => {
  return (
    <Stack
      sx={{
        gap: "16px",
        border: "1px solid #D9D9D9",
        borderRadius: "8px",
        padding: "16px",
        width: "100%",
      }}
    >
      <Stack gap="8px">
        <Stack flexDirection="row" gap="4px" alignItems="center">
          {icon}
          <Typography
            component="span"
            variant="button"
            color="custom.textDarkBlue"
          >
            {title}
          </Typography>
        </Stack>
        <Typography component="span" variant="caption" color="#4C545B">
          {text}
        </Typography>
      </Stack>
      {customBtnBlock ? (
        customBtnBlock
      ) : (
        <>
          {isSynced ? (
            <Stack flexDirection="row" gap="4px">
              <Typography component="span" variant="button" color="#4C545B">
                Synced
              </Typography>
              <CheckInCircleIcon />
            </Stack>
          ) : (
            <Stack flexDirection="row" gap="8px">
              <CustomButton
                onClick={btnHandler}
                variant="outlined"
                customColor="#FFFFFF"
                textColor="#1D3E70"
                type="button"
                customSize="fit"
                sx={{
                  height: "36px",
                  borderColor: "#1D3E70",
                }}
                disabled={isDisabled || isLoading}
              >
                Sync Data{" "}
                {isLoading && <CircularProgress size={20} color="inherit" />}
              </CustomButton>
              {extraBtn}
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};
